/**
 * School View visibility (v3.78.1) — ONE predicate for the routes, the sidebar
 * entry and the "School View" section banner on the TLS pages, so they can
 * never disagree: with the flag off on prod, none of them render.
 */
import { isFeatureEnabled } from '../constants/featureFlags';

export function canSeeSchoolView(user) {
  return isFeatureEnabled('schoolView') && isFeatureEnabled('tlsRole') && !!(user?.role?.tls || user?.role?.admin);
}
